import clsx from 'clsx';
import { Fragment } from 'react';

import { PlayersOnStandings, StandingsColumn } from '@/modules/league/new-components/types';
import { LeagueSessionUpDownTotalsData } from '@/modules/league/new-components/types';

interface TotalsDataRowProps {
  totals: LeagueSessionUpDownTotalsData[];
  player: PlayersOnStandings;
  columns: StandingsColumn[];
  matchingTotal: LeagueSessionUpDownTotalsData | undefined;
}

const renderContent = (
  column: StandingsColumn,
  player: PlayersOnStandings,
  total?: LeagueSessionUpDownTotalsData
) => {
  if (!column.totalKey) {
    if (column.label === '# Played') {
      return player.TotalMatchDate_Played > 0 ? player.TotalMatchDate_Played : null;
    } else if (column.label === 'Previous') {
      return 'Totals';
    }
    return null;
  }

  return total ? total[column.totalKey] : '0';
};

export default function TotalsDataRow({
  totals,
  player,
  columns,
  matchingTotal,
}: TotalsDataRowProps) {
  return (
    <>
      {matchingTotal && totals.length > 0 ? (
        totals
          .filter((total) => total.SessionTeamID === player.SessionTeamID)
          .map((total, j) => {
            return (
              <Fragment key={`player-up-down-total-row-${j}`}>
                {columns.map((column, idx) => {
                  const isFirstThreeColumns = idx === 0 || idx === 1 || idx === 2;
                  return (
                    <div
                      key={`player-up-down-total-cell-${j}-${idx}`}
                      className={clsx(
                        'inline-flex shrink-0 justify-center break-words border-r px-2 py-4 text-sm',
                        { 'bg-white': isFirstThreeColumns },
                        column.width
                      )}
                    >
                      {renderContent(column, player, total)}
                    </div>
                  );
                })}
              </Fragment>
            );
          })
      ) : (
        <>
          {columns.map((column, idx) => {
            const isFirstThreeColumns = idx === 0 || idx === 1 || idx === 2;
            return (
              <div
                key={`player-up-down-total-column-${idx}`}
                className={clsx(
                  'inline-flex shrink-0 justify-center break-words border-r px-2 py-4 text-sm',
                  { 'bg-white': isFirstThreeColumns },
                  column.width
                )}
              >
                {renderContent(column, player)}
              </div>
            );
          })}
        </>
      )}
    </>
  );
}
